import { render, staticRenderFns } from "./QuoteEmailAttachments.vue?vue&type=template&id=a45436fe"
import script from "./QuoteEmailAttachments.vue?vue&type=script&lang=js"
export * from "./QuoteEmailAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports